import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SchemaAlert } from '@hm_app/@core/models/alerts';

@Injectable()
export class AlertService {

    // Observable sources
    private alert = new BehaviorSubject<SchemaAlert>(null);

    // Observable streams
    alertObservable = this.alert.asObservable();

    // Service message commands
    passAlert(alert: SchemaAlert) {
        this.alert.next(alert);
        // console.log(this.alert)
    }
}
